function animate(element, property, to, duration) {
	return new Promise((resolve) => {
		const start = performance.now();
		const from = parseFloat(getComputedStyle(element)[property]);
		const change = to - from;
	
		function step(timestamp) {
			const timeElapsed = timestamp - start;
			const progress = Math.min(timeElapsed / duration, 1);
			element.style[property] = from + progress * change + 'px';
			
			if (progress < 1) {
				requestAnimationFrame(step);
			} else {
				resolve();
			}
		}
	
		requestAnimationFrame(step);
	})
}

function isMobile(eleQuery)
{
	const mobileHeadLabel = document.querySelector(eleQuery);
	
	if(window.getComputedStyle(mobileHeadLabel).display == "none") {
		return false;
	}
	
	return true;
}

function setTabElement()
{
	if (window.outerWidth <= 654) {
		window['detailTabElements'] = 'input[name="detail-information-mobile"]';
	} else {
		window['detailTabElements'] = 'input[name="detail-information"]';
	}
}

function resetTabs(tabInputs)
{
	tabInputs.forEach((tab, index) => {
		const resetTabPanel = document.querySelector(`label[for="${tab.id}"]`);
		
		if (index > 0) {
			tab.checked = false;
		} else {
			tab.checked = true;
		}
		
		if (window.outerWidth <= 654) {
			if (index > 0) {
				resetTabPanel.nextElementSibling.style.height = 0;
			} else {
				resetTabPanel.nextElementSibling.style.height = resetTabPanel.nextElementSibling.scrollHeight + 'px';
			}
		} else {
			tab.nextElementSibling.childNodes[3].style.height = '';
		}
		
		if (window.outerWidth > 1034) {
			resetTabPanel.parentElement.classList.remove("detail-tabs__title--active");
			
			if (index == 0) {
				resetTabPanel.parentElement.classList.add("detail-tabs__title--active");
			}
		}
	});
}

document.addEventListener("DOMContentLoaded", (dom) => {
	// Get all tab inputs
	setTabElement();
	
	let tabInputs = document.querySelectorAll(window['detailTabElements']);
	
	window.addEventListener("resize", (winDom) => {
		setTabElement();
		tabInputs = document.querySelectorAll(window['detailTabElements']);
		
		resetTabs(tabInputs);
	})
	
	// Set the first tab as always active
	const firstTabInput = tabInputs[0];
	if(firstTabInput) {
		firstTabInput.checked = true;
	
		// add class to the first active tab
		const firstTabId = firstTabInput.getAttribute("id");
		const firstTabParent = document.querySelector(`label[for="${firstTabId}"]`).parentElement;
		
		if (window.outerWidth > 1034) {
			firstTabParent.classList.add("detail-tabs__title--active");
		}
	}
	
	tabInputs.forEach((tab, index) => {
		const mobileEleQuery = `label[class="detail-tabs__mobile-heading"][for="${tab.id}"]`;
		if (isMobile(mobileEleQuery)) {
			const mobileWrapper = document.querySelector(mobileEleQuery).nextElementSibling;
			
			if (index != 0) {
				mobileWrapper.style.height = 0;
			}
		}
		
		tab.addEventListener("change", function(selectedTab) {
			const tabId = selectedTab.target.getAttribute("id");
			const selectedMobileTab = `label.detail-tabs__mobile-heading[for="${tabId}"]`;
			
			tabInputs.forEach(tab => {
				if (tab.id != selectedTab.target.id) {
					tab.checked = false;
				}
				
				const thisMobileTab = `label.detail-tabs__mobile-heading[for="${tab.id}"]`;
				if (isMobile(thisMobileTab)) {
					const thisWrapper = document.querySelector(thisMobileTab).nextElementSibling;
					animate(thisWrapper, 'height', 0, 200);
				}
			});
			
			const detailTabTitles = document.querySelectorAll(".detail-tabs__title");
			detailTabTitles.forEach(title => {
				title.classList.remove("detail-tabs__title--active");
			});
			
			const tabParent = document.querySelector(`label[for="${tabId}"]`).parentElement;
			if (window.outerWidth > 1034) {
				tabParent.classList.add("detail-tabs__title--active");
			}
			
			if (selectedTab.target.checked && isMobile(selectedMobileTab)) {
				const wrapperMobile = document.querySelector(selectedMobileTab).nextElementSibling;
				animate(wrapperMobile, 'height', wrapperMobile.scrollHeight, 200).then(() => {
					setTimeout(function(){
						document.querySelector(selectedMobileTab).scrollIntoView();
					},450);
				});
			}
		});
	});
});